import { render } from "./SignInCode.vue?vue&type=template&id=236fb85e"
import script from "./SignInCode.vue?vue&type=script&lang=js"
export * from "./SignInCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__